import { render, staticRenderFns } from "./Ro.vue?vue&type=template&id=34c6d000&"
import script from "./Ro.vue?vue&type=script&lang=js&"
export * from "./Ro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports